import APIService from '@/services/APIService.js'; 

export default {
  getDadosByNome(nome) {
    return APIService.apiCall().get(`/consultas/getConsultaDashboard/${nome}`);
  }
};